import styled from "styled-components";

export const CMSpan = styled.span(props => ({
    color: props.theme.palette.primary.main,
}));